module.exports = __webpack_public_path__ + "media/images/sp/top/recommend_plan_maedori@3x-79c622f8e12bb2dbf068238f18811e1c.webp";